import {useEffect,useState} from 'react';
import {getAttributeGroups} from '../../../../../api/attributes';

export const useAvailableAttributeGroups=productId=>{
 const [groups,setGroups]=useState([]);
 const [loading,setLoading]=useState(true);
 const [error,setError]=useState('');
 const [attempt,setAttempt]=useState(0);
 useEffect(()=>{
  let active=true;
  setGroups([]);setLoading(true);setError('');
  const load=async()=>{
   try{
    const response=await getAttributeGroups();
    if(!response||response.error||!Array.isArray(response.data))throw new Error('Unavailable groups');
    if(active)setGroups(response.data);
   }catch{
    if(active)setError('No se pudieron cargar los atributos disponibles. Vuelve a intentarlo.');
   }finally{if(active)setLoading(false);}
  };
  load();
  return()=>{active=false;};
 },[productId,attempt]);
 return {groups,loading,error,retry:()=>setAttempt(value=>value+1)};
};
